import { render, staticRenderFns } from "./inicial.vue?vue&type=template&id=c94cdbd6"
import script from "./inicial.vue?vue&type=script&lang=js"
export * from "./inicial.vue?vue&type=script&lang=js"
import style0 from "./inicial.vue?vue&type=style&index=0&id=c94cdbd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports